import { ACCESS_DOMAINS, APIMethod, fetchData } from "@client";

/**
 * Wywołuje endpoint /api/pdf/vector do generowania PDF z opcjami wektorowymi
 * @param {string} url - URL strony do renderowania (np. pełny URL do /print/...)
 * @param {Object} options - Opcje generowania PDF
 * @param {string} options.format - Format strony (A4, A3, A5, Letter, Legal, Tabloid)
 * @param {boolean} options.autoScale - Czy automatycznie dobierać skalę (true = ignoruje scale, waitUntil, delayMs, printBackground, preferCSSPageSize)
 * @param {number} options.scale - Skala renderowania (0.1-2.0)
 * @param {boolean} options.printBackground - Czy drukować tła CSS
 * @param {string} options.waitUntil - Strategia oczekiwania (zawsze "load" - inne opcje nie działają poprawnie)
 * @param {number} options.delayMs - Opóźnienie przed generowaniem (0-5000ms)
 * @param {string} options.width - Szerokość strony (np. "210mm", "8.5in")
 * @param {string} options.height - Wysokość strony (np. "297mm", "11in")
 * @param {string} options.renderTimeline - Czy rysować timeline
 * @param {boolean} options.preferCSSPageSize - Czy używać rozmiaru z CSS @page
 * @param {Function} onDownloadProgress - Callback dla progressu pobierania
 * @returns {Promise<Blob>} - Blob z PDF
 */
export async function exportPdfVectorQuery(url, options = {}, onDownloadProgress) {
  const filteredOptions = Object.fromEntries(
    Object.entries(options).filter(([, value]) => value !== undefined)
  );

  return  fetchData(
    "/api/pdf/vector",
    APIMethod.GET,
    {
      responseType: "blob",
      onDownloadProgress,
      params: { url, ...filteredOptions },
      mapRequestKeysToSnakeCase: false,
      baseURL: ACCESS_DOMAINS.pdfExport,
      timeout: 5 * 60 * 1000,
    }
  );
}
